<template>
<div class="get-token">
    <Spin ></Spin>
</div>
</template>

<script>
import settings from '@/utils/settings';
import axios from '@/service/interceptor';
import * as types from '@/store/mutation-types';
import Utils from '@/utils/Utils';
//import $ from "jquery";
export default {

    data() {
        return {

        }
    },
    computed: {
        currAccountIndex() {
            return this.$store.state.currAccountIndex;
        },
        user() {
            return this.$store.state.user;
        },
        accountList() {
            return this.$store.state.accountList;
        },
    },
    mounted() {
        let self = this;
        let query = Utils.getQueryObject()
        let token = query.token
        axios.post(`${settings.HOST}/api/v1`, {
            cmd: "getTokenInfo",
            token: token,
        }).then(function (data) {

            if (data.data.code === 0) {

                data.data.data.token = token;
                localStorage.setItem(token, JSON.stringify(data.data.data))
                if (data.data.data.isRegister) {
                    if(self.user && self.user.email) {
                        if(self.user.email === data.data.data.email) {
                            return self.$router.push(`/Balance?token=${token}`)
                        } else {
                            self.$store.commit(types.LOGOUT);
                            localStorage.setItem('session', '{}');
                            return self.$router.push(`/Loign?token=${token}`)
                        }
                    }
                    return self.$router.push(`/login?token=${token}`)
                } else {
                    return self.$router.push(`/Reg?token=${token}`)
                }
            } else {
                return self.$Message.error('Error');
            }
        })
    },

    methods: {

    }
}
</script>
<style scoped>
.get-token {
    display: flex;
    align-items: center;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/GetToken.vue